import { ForwardRefExoticComponent, RefAttributes } from "react";

import { Icon, IconProps } from "@tabler/icons-react";
import { format } from "date-fns";
import { useTranslations } from "next-intl";

import IconCalendar from "@/icons/calendar-bold.svg";
import IconArea from "@/icons/content/property/area-bold.svg";
import IconBathroom from "@/icons/content/property/bath.svg";
import IconBuildings from "@/icons/content/property/buildings-bold.svg";
import IconRooms from "@/icons/content/property/door-open.svg";
import IconFloor from "@/icons/content/property/stairs-bold.svg";
import IconBedroom from "@/icons/icon_bed.svg";
import IconStudio from "@/icons/intersaction.svg";

interface ConfigType {
  name: string;
  translateValue: string;
  value: string | number;
  Icon: ForwardRefExoticComponent<IconProps & RefAttributes<Icon>>;
}

export type Characteristics = (property: any, layout: any) => ConfigType[];

export const usePlanCharacteristicsConfig: Characteristics = (
  property,
  layout,
) => {
  const t = useTranslations();
  const tPropertyType = useTranslations("PropertyType");

  return [
    {
      name: "layout.rooms",
      translateValue: t("Premises"),
      value: layout?.rooms || '—',
      Icon: IconRooms,
    },
    {
      name: "layout.area",
      translateValue: t("Area"),
      value: layout?.area || '—',
      Icon: IconArea,
    },
    {
      name: "layout.floors",
      translateValue: t("Floors"),
      value: layout?.floors || '—',
      Icon: IconFloor,
    },
    {
      name: "property.mainInfo.objectType",
      translateValue: t("A feature of the layout"),
      value: property?.mainInfo?.objectType
          ? tPropertyType(property.mainInfo.objectType)
          : '—',
      Icon: IconStudio,
    },
    {
      name: "layout.bedrooms",
      translateValue: t("Bedrooms"),
      value: layout?.bedrooms || '—',
      Icon: IconBedroom,
    },
    {
      name: "layout.bathrooms",
      translateValue: t("Bathrooms"),
      value: layout?.bathrooms !== undefined
        ? t("pluralization.bathrooms", { count: layout.bathrooms })
        : '—',
      Icon: IconBathroom,
    },
    {
      name: "property.developer.name",
      translateValue: t("Developer"),
      value: property?.developer?.name || '—',
      Icon: IconBuildings,
    },
    {
      name: "property.project.name",
      translateValue: t("Residential complex"),
      value: property?.project?.name || '—',
      Icon: IconBuildings,
    },
    {
      name: "relevant",
      translateValue: t("Current as of"),
      value: format(new Date(), "dd.MM.yyyy"),
      Icon: IconCalendar,
    },
  ];
};
